module.exports = __webpack_public_path__ + "static/media/delhivery_color.82e28832.jpg";